import { createAsyncThunk } from '@reduxjs/toolkit';
import { createRequest } from '../../../helpers/api/createRequest';
import * as faqApi from '../../../api/faq';
import { GetFaqListParams } from '../../../types/Endpoints/faq/FaqContracts';

export const GET_FAQ_LIST = 'faq/getFaqList';

export const getFaqList = createAsyncThunk(
    GET_FAQ_LIST,
    createRequest({
        type: GET_FAQ_LIST,
        loader: async (params: GetFaqListParams) => faqApi.getFaqList(params),
    }),
);
